<form [formGroup]="form1">
  <mat-card>
    <mat-card-header>
      <mat-card-title>Event</mat-card-title>
    </mat-card-header>
    <mat-card-content class="container-fluid">
      <div class="row">
        <mat-form-field class="col-md-5">
          <mat-label>Start Date</mat-label>
          <input matInput [matDatepicker]="eventStartDatePicker" placeholder="EventStart Date" formControlName="eventStartDate">
          <mat-datepicker-toggle matSuffix [for]="eventStartDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #eventStartDatePicker disabled="false"></mat-datepicker>
          @for (validation of validationMessages.eventStartDate; track validation) {
            <mat-error>
              @if (form1.get('eventStartDate').hasError(validation.type) && (form1.get('eventStartDate').dirty || form1.get('eventStartDate').touched)) {
                <mat-error class="error-message">
                {{validation.message}}</mat-error>
              }
            </mat-error>
          }
        </mat-form-field>

        <mat-form-field class="col-md-4">
          <mat-label>Start Time</mat-label>
          <mat-select [(value)]="form1.value.eventStartTime" formControlName="eventStartTime">
            @for ( i of time; track  i) {
              <mat-option [value]="i.value"> {{i.name}} </mat-option>
            }
          </mat-select>
          @for (validation of validationMessages.eventStartTime; track validation) {
            <mat-error>
              @if (form1.get('eventStartTime').hasError(validation.type) && (form1.get('eventStartTime').dirty || form1.get('eventStartTime').touched)) {
                <mat-error class="error-message">
                {{validation.message}}</mat-error>
              }
            </mat-error>
          }
        </mat-form-field>

        <mat-form-field class="col-md-3">
          <mat-label>Time Zone</mat-label>
          <mat-select [(value)]="form1.value.timeZone" formControlName="timeZone">
            @for ( i of timeZones; track  i) {
              <mat-option [value]="i.value"> {{i.name}} </mat-option>
            }
          </mat-select>
          @for (validation of validationMessages.timeZone; track validation) {
            <mat-error>
              @if (form1.get('timeZone').hasError(validation.type) && (form1.get('timeZone').dirty || form1.get('timeZone').touched)) {
                <mat-error class="error-message">
                {{validation.message}}</mat-error>
              }
            </mat-error>
          }
        </mat-form-field>
      </div>

      <div class="row">
        <mat-form-field class="col-md-5">
          <mat-label>End Date</mat-label>
          <input matInput [matDatepicker]="eventEndDatePicker" formControlName="eventEndDate">
          <mat-datepicker-toggle matSuffix [for]="eventEndDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #eventEndDatePicker disabled="false"></mat-datepicker>
          @for (validation of validationMessages.eventEndDate; track validation) {
            <mat-error>
              @if (form1.get('eventEndDate').hasError(validation.type) && (form1.get('eventEndDate').dirty || form1.get('eventEndDate').touched)) {
                <mat-error class="error-message">
                  {{validation.message}}
                </mat-error>
              }
            </mat-error>
          }
        </mat-form-field>


        <mat-form-field class="col-md-4">
          <mat-label>End Time</mat-label>
          <mat-select [(value)]="form1.value.eventEndTime" formControlName="eventEndTime">
            @for ( i of time; track  i) {
              <mat-option [value]="i.value"> {{i.name}} </mat-option>
            }
          </mat-select>
          @for (validation of validationMessages.eventEndTime; track validation) {
            <mat-error>
              @if (form1.get('eventEndTime').hasError(validation.type) && (form1.get('eventEndTime').dirty || form1.get('eventEndTime').touched)) {
                <mat-error class="error-message">
                  {{validation.message}}
                </mat-error>
              }
            </mat-error>
          }
        </mat-form-field>
        <div class="col-md-3"></div>
      </div>
      <mat-form-field class="flex-1">
        <mat-label>Location</mat-label>
        <input matInput formControlName="location" readonly="{{formReadOnly}}">
        @for (validation of validationMessages.location; track validation) {
          <mat-error>
            @if (form1.get('location').hasError(validation.type) && (form1.get('location').dirty || form1.get('location').touched)) {
              <mat-error class="error-message">
                {{validation.message}}
              </mat-error>
            }
          </mat-error>
        }
      </mat-form-field>


      <mat-accordion>
        <mat-expansion-panel style="background-color: #f9f9f9;" [expanded]="false" hideToggle="true" #interval>
          <mat-expansion-panel-header>
            <mat-panel-title>
              @if (!interval?.expanded) {
                <mat-icon style="color:green; font-size:140%">add_circle</mat-icon>
              }
              @if (interval?.expanded) {
                <mat-icon style="color:grey; font-size:140%">unfold_less</mat-icon>
              }
              &nbsp;Repeat

            </mat-panel-title>
            <mat-panel-description>@if (this.intervalTaskRepeat&&this.intervalTaskRepeat.frequency!=0) {
              <span style="color:green; border:1px solid lightgrey">&nbsp;[On]&nbsp;</span>
            }
          </mat-panel-description>
        </mat-expansion-panel-header>
        <app-interval-select [taskId]="this.taskId" [interval]="this.intervalTaskRepeat" intervalType="1">
        </app-interval-select>
      </mat-expansion-panel>
    </mat-accordion>
  </mat-card-content>
</mat-card>
</form>
